import { numericOperators, stringOperators, booleanOperators } from '../EnvQueryConfig';
// Determines if a field type is numeric based on variable type and translation status
const isNumberType = (variableType) => {
  return variableType === 'USINT' || variableType === 'UDINT' || variableType === 'UINT' || variableType === 'REAL';
};

const isNumericFieldType = (variableType, hasTranslation) => {
  if (!variableType || hasTranslation) return false;
  return isNumberType(variableType);
};

// Helper to determine appropriate operators based on variable type
export const getOperatorsForField = (variableType, hasTranslation) => {
  if (hasTranslation) {
    return stringOperators;
  }
  
  if (isNumericFieldType(variableType, hasTranslation)) {
    return numericOperators;
  }
  
  if (variableType === 'BOOL') {
    return booleanOperators;
  }
  
  return stringOperators;
};

export const getInputTypeForField = (variableType, hasTranslation) => {
    // Fields with translations are always text (e.g., car type)
  if (!variableType || hasTranslation) return 'text';
  
  if (isNumericFieldType(variableType, hasTranslation)) {
    return 'number';
  }
  
  if (variableType === 'BOOL') {
    return null; // Boolean fields don't need an input type
  }
  
  return 'text';
};
